<template>
  <div class="pa-5 w-full" v-if="recipe?._id">
    <v-row>
      <v-col cols="12">
        <h1>Rezept "{{ recipe.title }}" bearbeiten</h1>
      </v-col>
      <v-col cols="12" md="6">
        <v-row>
          <v-col cols="12">
            <v-row v-for="(ingredient, index) in recipe.ingredients" :key="index">
              <v-col cols="12" sm="11">
                <v-text-field
                  label="Zutat-Titel"
                  hide-details
                  v-model="recipe.ingredients[index]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="1">
                <v-icon icon="mdi-minus" @click="removeIngredient(index)"></v-icon>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-btn color="primary" append-icon="mdi-plus" @click="addIngredient"
              >Zutat hinzufügen</v-btn
            >
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="6">
        <v-row>
          <v-col cols="12">
            <v-row v-for="(instruction, index) in recipe.instructions" :key="index">
              <v-col cols="12" sm="11">
                <v-textarea
                  label="Anweisung"
                  hide-details
                  v-model="recipe.instructions[index]"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="1">
                <v-icon icon="mdi-minus" @click="removeInstruction(index)"></v-icon>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-btn color="primary" append-icon="mdi-plus" @click="addInstruction"
              >Anweisung hinzufügen</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-btn color="primary" append-icon="mdi-content-save" @click="updateRecipe"
          >Rezept speichern</v-btn
        >
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-btn color="secondary" append-icon="mdi-eye" @click="viewRecipe">Rezept ansehen</v-btn>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-btn color="error" append-icon="mdi-trash-can" @click="removeRecipe"
          >Rezept löschen</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>
<script src="./RecipeEdit.js"></script>
